import { DownOutlined, EyeOutlined, MenuOutlined } from "@ant-design/icons";
import Icon, { Button, Col, Dropdown, Layout, Menu, Row } from "antd";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./index.scss";
import { nofication } from "./../../commons/Nofication";
import { ROOT_URL } from "./../../constants/api";

const { SubMenu } = Menu;
const { Header } = Layout;
const HEADER_HEIGHT = 64;

const headerStyle = {
    marginBottom: 4,
    padding: 0,
    // position: "fixed",
    zIndex: 3,
    background: "black",
    width: "100%",
};

const Navbar = ({ setToggleMenu, toggleMenu, visible, setVisible }) => {
    const navigate = useNavigate();
    const logout = () => {
        localStorage.removeItem("ACCESS_TOKEN_STORED");
        localStorage.removeItem("username");
        navigate("/login");
        nofication("success", "Thành công", "Đăng xuất thành công");
    };

    const menu = (
        <Menu
            items={[
                {
                    key: "1",
                    label: <div onClick={logout}>Đăng xuất</div>,
                },
            ]}
        />
    );

    const onToggleMenu = () => {
        const { innerWidth: width, innerHeight: height } = window;
        if (width < 990) {
            setVisible(!visible);
        } else {
            setToggleMenu(!toggleMenu);
        }
    };
    const username = localStorage.getItem("username") ?? "noName";

    return (
        <Row className="menu-top">
            <Col span={4} xs={0} sm={0} md={0} lg={5} xl={4} xxl={4}>
                <Header
                    style={{
                        padding: 0,
                        backgroundColor: "black",
                        borderRight: "1px solid grey",
                    }}
                >
                    <Row align="middle" justify="center">
                        <a href="https://www.saijinagency.com" tatget="_blank">
                            <img
                                src="/icon/logomain.svg"
                                alt=""
                                className="logo-left"
                            />
                        </a>
                    </Row>
                </Header>
            </Col>
            <Col span={20} xs={24} sm={24} md={24} lg={19} xl={20} xxl={20}>
                <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={0}
                    xl={0}
                    xxl={0}
                    style={{
                        height: HEADER_HEIGHT,
                        borderBottom: "1px solid grey",
                        backgroundColor: "black",
                    }}
                >
                    <a href="http://kcntaybachoxa.com.vn/" target="_blank">
                        <img
                            src="/icon/amber-KCN.svg"
                            alt=""
                            style={{
                                width: "235px",
                                display: "block",
                                margin: "auto",
                                padding: 17,
                            }}
                        />
                    </a>
                </Col>
                <Header style={headerStyle}>
                    <Col span={24}>
                        <Row justify="space-between" align="center">
                            <Col
                                xs={3}
                                sm={3}
                                md={1}
                                style={{ height: HEADER_HEIGHT }}
                            >
                                <img
                                    onClick={onToggleMenu}
                                    src="/icon/bar.svg"
                                    className="menu-img"
                                    style={{
                                        marginTop: 27,
                                        marginLeft: 20,
                                        cursor: "pointer",
                                        width: 23,
                                    }}
                                />
                            </Col>
                            <Col
                                xs={0}
                                sm={0}
                                md={0}
                                lg={8}
                                xl={10}
                                xxl={17}
                                style={{ height: HEADER_HEIGHT }}
                                className="logo-top-main"
                            >
                                <a href="http://kcntaybachoxa.com.vn/" target="_blank">
                                    <img
                                        src="/icon/amber-KCN.svg"
                                        alt=""
                                        style={{
                                            width: "235px",
                                            marginTop: 17,
                                        }}
                                    />
                                </a>
                            </Col>

                            <Col
                                xs={20}
                                sm={20}
                                md={23}
                                lg={10}
                                xl={8}
                                xxl={6}
                                style={{ height: HEADER_HEIGHT }}
                                className="navbar-left"
                            >
                                {/* <button className="anhquy">ssssssssssssss</button> */}
                                <a
                                    href="http://kcntaybachoxa.com.vn/"
                                    target="_blank"
                                >
                                    <img
                                        src="/icon/eye.svg"
                                        alt=""
                                        className="eye"
                                    />
                                </a>
                                <span>
                                    <a
                                        href="http://kcntaybachoxa.com.vn/"
                                        target="_blank"
                                        style={{
                                            color: "white",
                                        }}
                                    >
                                        View Website
                                    </a>
                                </span>
                                <div>
                                    <img src={`${localStorage.getItem('avatar')  && localStorage.getItem('avatar') !== 'null' ? ROOT_URL + localStorage.getItem('avatar') : '/icon/avatar.svg'}`} alt="" />
                                </div>

                                <Dropdown
                                    overlay={<></>}
                                    placement="bottom"
                                >
                                    <Button
                                        style={{
                                            color: "white",
                                            background: "black",
                                            border: "black",
                                        }}
                                    >
                                        {username}
                                    </Button>
                                </Dropdown>

                                {/* <DownOutlined style={{ color: 'white' }} /> */}
                                <div className="toggle-user">
                                    <Link to={`/profile/edit/${localStorage.getItem('id')}`}>
                                        <Button>Profile</Button>
                                    </Link>
                                    <Button
                                        onClick={logout}
                                        icon={
                                            <img
                                                src="/icon/signout.svg"

                                            />
                                        }
                                    >
                                        Sign out
                                    </Button>
                                </div>
                                <img src="/icon/ar.png" alt="" className="ar" />
                            </Col>
                        </Row>
                    </Col>
                </Header>
            </Col>
        </Row>
    );
};
export default Navbar;
